module.exports = __webpack_public_path__ + "create/static/media/bannerA5_Fundo.cace2fc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/CreateExperience/Institucional/bannerA5_Fundo.png
// module id = 478
// module chunks = 39